export const API_BASE_URL = process.env.REACT_APP_URL;

export const BASE_URL = `${API_BASE_URL}/api/v1`;
export const AUTH_SERVICE_LOGIN = process.env.REACT_APP_AUTH_SERVICE_API_ENDPOINT_URL;
export const AUTH_SERVICE_FORGOT_PASSWORD = `${BASE_URL}/admin/forget-password`;
export const AUTH_SERVICE_SET_PASSWORD = `${BASE_URL}/admin/reset-password`;
